import React, { useEffect } from 'react';
import { MdChat, MdChatBubble } from 'react-icons/md';
import { Container, Sponsor, SponsorGrid } from './styles';
import { Button } from '../../components/Button/styles';
import Sponsors from '../Sponsors';
import Particles from 'react-particles-js';
import ImageSliderBackground from '../../components/ImageBackgroundSlider';

const FooterLayout: React.FC = ({ children }) => {

  return ( <div style={{width: '100%', zIndex:100, position:'relative', display:'flex', alignItems:'center', justifyContent:'center', padding: '15px', flexDirection: 'column'}}> 
  <div className='programDayHeader'>
  <h2 style={{fontSize: '14px', margin: '5px auto'}} >Em caso de dúvidas, entre em contato: contato@unimedcentralrs.coop.br</h2>

  </div>

  <div className='programDayHeader'>
<h2 style={{fontSize: '14px', margin: '5px auto'}} >  <a href="https://www.unimed.coop.br/site/web/centralrs" target='_BLANK' style={{color: '#fff', textDecoration:'none'}}> Visite nosso website: https://www.unimed.coop.br/site/web/centralrs</a></h2>

  </div>


  <div style={{display:'flex', width: '100%', alignItems:'flex-start', justifyContent:'center', flexWrap:'wrap'}}>
 
  <div style={{padding:'15px', flexDirection:'column', display:'flex', margin: '10px', justifyContent:'flex-start', alignItems:'center'}}>
  <h2 style={{marginBottom:'15px', margin: '10px auto', color: 'rgb(43,152,97)'}}>Organização</h2>
    <img style={{width: '100%', maxWidth:'200px'}} src="/apoio/logo1.png"/>
  </div>

  <div style={{padding:'15px', flexDirection:'column', display:'flex', margin: '10px', justifyContent:'flex-start', alignItems:'center'}}>
  <h2 style={{marginBottom:'15px', margin: '10px auto', color: 'rgb(43,152,97)'}}>Apoio</h2>
    <img style={{width: '100%', maxWidth:'200px'}} src="/apoio/logo2.png"/>
  </div>
</div></div>)

};

export default FooterLayout;
